export default "__VITE_ASSET__70EzxCim__"